import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as shiftAction from '../actions/shift.action';
import {map, mergeMap, take} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {ShiftService} from '../../shift.service';

@Injectable()
export class ShiftEffect {
  constructor(private actions: Actions, private shiftService: ShiftService) {
  }

  @Effect()
  getAllShifts: Observable<Action> = this.actions.ofType(shiftAction.GET_ALL_SHIFTS)
    .pipe(
      map((action: shiftAction.GetAllShifts) => action.payload),
      mergeMap(body => {
        return this.shiftService.getPopupShifts(body.startDate, body.endDate)
          .map(r => new shiftAction.GetAllShiftsSuccess(r))
          .catch(e => of(new shiftAction.GetAllShiftsFail(e)));
  }));

  @Effect()
  getShiftDetails: Observable<Action> = this.actions.ofType(shiftAction.GET_SHIFT_DETAILS)
    .pipe(
      map((action: shiftAction.GetShiftDetails) => action.payload),
      mergeMap(body => {
        return this.shiftService.getShiftDetails(body)
          .map(r => new shiftAction.GetShiftDetailsSuccess(r))
          .catch(e => of(new shiftAction.GetShiftDetailsError(e)));
  }));

  @Effect()
  createShift: Observable<Action> = this.actions.ofType(shiftAction.CREATE_SHIFT)
    .pipe(
      map((action: shiftAction.CreateShift) => action.payload),
      mergeMap(body => {
        return this.shiftService.createPopupShift(body)
          .map(r => new shiftAction.CreateShiftSuccess(r))
          .catch(e => of(new shiftAction.CreateShiftFail(e)));
  }));

  @Effect()
  deleteShift: Observable<Action> = this.actions.ofType(shiftAction.DELETE_SHIFT)
    .map((action: shiftAction.DeleteShift) => action.payload)
    .pipe(
      mergeMap(body => {
        return this.shiftService.deletePopupShift(body)
          .map(res => {
            return new shiftAction.DeleteShiftSuccess(res)})
          .catch(error => of(new shiftAction.DeleteShiftFail(error)));
      })
    );


}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shifts/store/effects/shift.effect.ts